// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { signInPageLayout } from "@sc/App/Widgets/Layout/SignInPageLayout";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

signInPageLayout.container = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100vw;
        position: relative;
        left: 50%;
        right: 50%;
        margin: 44px -50vw 0 -50vw;
        ${xScreen("lte", "md")} {
            padding: 0 16px;
        }
    `,
};

signInPageLayout.logoSection = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 44px;
        & > div {
            width: 100%;
            max-width: 660px;
            & > div {
                text-align: center;
                .wrapper {
                    height: auto;
                    display: inline-block;
                    &,
                    ${StyledButton}, ${TypographyStyle} {
                        width: 100%;
                    }
                }
            }
            ${xScreen("lte", "md")} {
                max-width: 485px;
            }
        }
    `,
};

signInPageLayout.notifySection = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        & > div {
            width: 100%;
            max-width: 660px;
            ${xScreen("lte", "md")} {
                max-width: 485px;
            }
        }
    `,
};

signInPageLayout.signInSection = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 2;
        padding-bottom: 135px;
        ${xScreen("lte", "md")} {
            padding-bottom: 44px;
        }
        & > div {
            width: 100%;
            max-width: 660px;
            ${xScreen("lte", "md")} {
                max-width: 485px;
            }
        }
    `,
};

signInPageLayout.pictureWrapper = {
    css: css`
        position: absolute;
        width: 100%;
        height: 100%;
        && ${LazyImageStyle} {
            height: 100%;
            width: 100%;
            picture[class^="LazyPictureStyle"] {
                width: 100%;
                height: 100%;
            }
            img {
                width: 100%;
                height: 100%;
            }
        }
    `,
};
